import { Lightning } from '@lightningjs/sdk';

export default class AutoscrollShader extends Lightning.shaders.WebGLDefaultShader {
  constructor(context) {
    super(context);
    this._top = 1.0;
    this._bottom = 1.0;
  }

  setupUniforms(operation) {
    super.setupUniforms(operation);
    this._setUniform('top', this._top, this.gl.uniform1f);
    this._setUniform('bottom', this._bottom, this.gl.uniform1f);
  }

  get top() {
    return this._top;
  }

  set top(value) {
    this._top = value;
    this.redraw();
  }

  get bottom() {
    return this._bottom;
  }

  set bottom(value) {
    this._bottom = value;
    this.redraw();
  }
}

AutoscrollShader.vertexShaderSource = `
    #ifdef GL_ES
    # ifdef GL_FRAGMENT_PRECISION_HIGH
    precision highp float;
    # else
    precision lowp float;
    # endif
    #endif
    attribute vec2 aVertexPosition;
    attribute vec2 aTextureCoord;
    attribute vec4 aColor;

    uniform vec2 projection;

    varying vec2 vTextureCoord;
    varying vec4 vColor;

    void main(void){
        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);
        vTextureCoord = aTextureCoord;
        vColor = aColor;
        gl_Position.y = -sign(projection.y) * gl_Position.y;
    }
`;

AutoscrollShader.fragmentShaderSource = `
    #ifdef GL_ES
    # ifdef GL_FRAGMENT_PRECISION_HIGH
    precision highp float;
    # else
    precision lowp float;
    # endif
    #endif

    varying vec2 vTextureCoord;
    varying vec4 vColor;

    uniform sampler2D uSampler;
    uniform float top;
    uniform float bottom;

    void main(void){
        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;

        float size = 0.1;
        float multiplier = 1.0 / size;

        float topMask = 1.0 - max((size * top - vTextureCoord.x) * multiplier, 0.0);
        float bottomMask = 1.0 - max((vTextureCoord.x - 1.0 + size * bottom) * multiplier, 0.0);

        gl_FragColor = color * topMask * bottomMask;
    }
`;
